function littleStarsCardVariants(root) {
    root = root || document;

    root
        .querySelectorAll('[data-littlestars-card-variants]')
        .forEach(function (variants) {

            if (variants.dataset.ready === 'true') {
                return;
            }

            variants.dataset.ready = 'true';

            var productCard = variants.closest('product-card');

            if (!productCard) {
                return;
            }

            /*
             * Horizon's product card gallery may contain several images.
             * We use the first visible product image as the card image.
             */
            function getMainImage() {
                var images = productCard.querySelectorAll(
                    '.product-card__content img'
                );

                for (var i = 0; i < images.length; i++) {
                    var image = images[i];

                    if (
                        image.closest('.littlestars-card-variants') == null &&
                        image.offsetParent !== null
                    ) {
                        return image;
                    }
                }

                return null;
            }

            variants
                .querySelectorAll('[data-littlestars-card-variant]')
                .forEach(function (variant) {

                    function showVariantImage() {
                        var image = getMainImage();

                        if (!image) {
                            return;
                        }

                        var variantImage = variant.dataset.variantImage;

                        if (!variantImage) {
                            return;
                        }

                        image.src = variantImage;

                        if (variant.dataset.variantImageSrcset) {
                            image.srcset =
                                variant.dataset.variantImageSrcset;
                        }

                        variants
                            .querySelectorAll(
                                '[data-littlestars-card-variant]'
                            )
                            .forEach(function (item) {
                                item.classList.remove('is-selected');
                            });

                        variant.classList.add('is-selected');
                    }

                    variant.addEventListener(
                        'mouseenter',
                        showVariantImage
                    );

                    variant.addEventListener(
                        'focus',
                        showVariantImage
                    );

                    /*
                     * Prevent Horizon's product-card overlay link from
                     * swallowing the variant interaction.
                     */
                    variant.addEventListener(
                        'click',
                        function (event) {
                            event.stopPropagation();
                        }
                    );
                });
        });
}

function littleStarsInitCardVariants() {
    littleStarsCardVariants(document);
}

littleStarsInitCardVariants();

/*
 * Horizon collection filtering / infinite-scroll can insert
 * new product cards after initial page load.
 */
var littleStarsCardObserver =
    new MutationObserver(function (mutations) {

        mutations.forEach(function (mutation) {

            mutation.addedNodes.forEach(function (node) {

                if (node.nodeType !== 1) {
                    return;
                }

                if (
                    node.matches &&
                    node.matches(
                        '[data-littlestars-card-variants]'
                    )
                ) {
                    littleStarsCardVariants(node.parentElement);
                    return;
                }

                if (node.querySelector) {
                    littleStarsCardVariants(node);
                }
            });
        });
    });

littleStarsCardObserver.observe(
    document.documentElement,
    {
        childList: true,
        subtree: true
    }
);
document.addEventListener(
    'shopify:section:load',
    function (event) {
        littleStarsCardVariants(event.target);
    }
);

/* Header behavior (moved from the inline section script). */

(function () {
  function buildLittleStarsBrandLists(root) {
    root = root || document;

    root.querySelectorAll('.littlestars-mega-menu-v2').forEach(function (megaMenu) {
      var brandList = megaMenu.querySelector('[data-shop-by-brand]');
      if (!brandList) return;

      var limit = parseInt(megaMenu.getAttribute('data-brand-limit') || '8', 10);
      var collectionsUrl = megaMenu.getAttribute('data-collections-url') || '/collections';
      var names = [];
      var seen = {};

      megaMenu.querySelectorAll('[data-vendor-name]').forEach(function (item) {
        var vendor = (item.getAttribute('data-vendor-name') || '').trim();
        var key = vendor.toLowerCase();
        if (!vendor || seen[key]) return;
        seen[key] = true;
        names.push(vendor);
      });

      names.sort(function (a, b) {
        return a.localeCompare(b, undefined, { sensitivity: 'base' });
      });

      brandList.querySelectorAll('[data-generated-brand]').forEach(function (item) {
        item.remove();
      });

      var allBrands = brandList.querySelector('[data-all-brands-link]');

      names.slice(0, limit).forEach(function (vendor) {
        var li = document.createElement('li');
        li.setAttribute('data-generated-brand', '');

        var a = document.createElement('a');
        a.href = collectionsUrl + '/vendors?q=' + encodeURIComponent(vendor);
        a.textContent = vendor;

        li.appendChild(a);
        if (allBrands) {
          brandList.insertBefore(li, allBrands);
        } else {
          brandList.appendChild(li);
        }
      });
    });
  }

  buildLittleStarsBrandLists(document);

  if (!window.littleStarsHeaderV2EditorEvents) {
    window.littleStarsHeaderV2EditorEvents = true;
    document.addEventListener('shopify:section:load', function (event) {
      buildLittleStarsBrandLists(event.target);
    });
    document.addEventListener('shopify:block:load', function () {
      buildLittleStarsBrandLists(document);
    });
    document.addEventListener('shopify:block:select', function () {
      buildLittleStarsBrandLists(document);
    });
  }
})();


/* Mobile navigation: move the existing account menu rather than clone links. */
(function () {
  function initHeader(root) {
    (root || document).querySelectorAll('.littlestars-header').forEach(function (header) {
      if (header.dataset.lsHeaderReady) return;
      header.dataset.lsHeaderReady = '1';
      var account = header.querySelector('.account-links');
      var destination = header.querySelector('[data-ls-mobile-secondary]');
      var nav = header.querySelector('.main-menu');
      var checkbox = header.querySelector('.menu-state');
      if (!account || !destination || !nav || !checkbox) return;
      var originalParent = account.parentNode;
      var marker = document.createComment('account-links original position');
      originalParent.insertBefore(marker, account);
      var mobile = window.matchMedia('(max-width: 749px)');
      function layout() {
        if (mobile.matches) destination.appendChild(account);
        else { originalParent.insertBefore(account, marker); checkbox.checked = false; }
      }
      layout();
      mobile.addEventListener('change', layout);
      header.querySelectorAll('.main-menu > ul > li > button').forEach(function (button) {
        button.addEventListener('click', function (event) {
          if (!mobile.matches) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          var item = button.closest('li');
          var open = !item.classList.contains('is-open');
          header.querySelectorAll('.main-menu > ul > li.is-open').forEach(function (other) {
            if (other !== item) {
              other.classList.remove('is-open');
              var otherButton = other.querySelector(':scope > button');
              if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
            }
          });
          item.classList.toggle('is-open', open);
          button.setAttribute('aria-expanded', String(open));
        });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && checkbox.checked) checkbox.checked = false;
      });
      document.addEventListener('click', function (event) {
        if (mobile.matches && checkbox.checked && !header.contains(event.target)) checkbox.checked = false;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initHeader(document); });
  else initHeader(document);
  document.addEventListener('shopify:section:load', function (event) { initHeader(event.target); });
})();

/* Refresh only the header basket amount after a successful AJAX cart mutation. */
(function () {
  var timer;
  function refreshBasket() {
    clearTimeout(timer);
    timer = setTimeout(async function () {
      var basket = document.querySelector('[data-ls-basket]');
      if (!basket) return;
      try {
        var response = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', {credentials: 'same-origin'});
        if (!response.ok) return;
        var cart = await response.json();
        var format = basket.dataset.moneyFormat || '${{amount}}';
        var cents = cart.total_price;
        var formatted = (cents / 100).toFixed(2);
        var match = format.match(/\{\{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?)\s*\}\}/);
        if (match) {
          var kind = match[1];
          var decimals = kind.includes('no_decimals') ? 0 : 2;
          formatted = (cents / 100).toFixed(decimals);
          if (kind.includes('comma_separator')) formatted = formatted.replace('.', ',');
          else formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          basket.querySelector('[data-ls-basket-total]').textContent = format.replace(match[0], formatted);
        } else {
          basket.querySelector('[data-ls-basket-total]').textContent = formatted;
        }
      } catch (_) { /* Preserve existing total if request fails. */ }
    }, 80);
  }
  document.addEventListener('cart:update', refreshBasket);
  document.addEventListener('cart:refresh', refreshBasket);
  document.addEventListener('ajaxProduct:added', refreshBasket);
  var originalFetch = window.fetch;
  window.fetch = function () {
    var request = arguments[0];
    var url = typeof request === 'string' ? request : request && request.url;
    var method = (arguments[1] && arguments[1].method) || (request && request.method) || 'GET';
    var result = originalFetch.apply(this, arguments);
    if (url && /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/.test(url) && method.toUpperCase() !== 'GET') {
      result.then(function (response) { if (response.ok) refreshBasket(); }, function () {});
    }
    return result;
  };
})();
